@if (menuParams) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="menuParams">
          <div class="control-div">
            <input #imageRef [formControlName]="'imageRef'" hidden>
            <select-media [image]="imageRef.value" [imageOnly]="true" (setImageRef)="setImage($event, menuParams)">
            </select-media>
            <input-validators controlName="imageRef" [control]="menuParams.controls['imageRef']"></input-validators>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Configure Form </label>
            </div>
            <div class="control-btn-container">
              <button [activeForm]="menuParams" class="configure-form-btn" (click)="openConfigureFormPanel()">Configure Form</button>
            </div>
            <input-validators controlName="configureForm" [control]="menuParams.controls['configureForm']"></input-validators>
          </div>
          <div class="control-div">
            <div class="var-name-top">
              <div class="control-label-container">
                <label class="control-label"> Variable Name </label>
              </div>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'varName'"></app-cms>
            </div>
            <input class="control-input" activeForm [activeForm]="menuParams" id="varName" [formControlName]="'varName'" placeholder="Enter name for variable"/>
            <input-validators controlName="varName" [control]="menuParams.controls['varName']"></input-validators>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Form Header </label>
            </div>
            <input class="control-input" activeForm [activeForm]="menuParams" id="formTitle" [formControlName]="'menuHeader'" placeholder="Enter a form header"/>
            <input-validators controlName="menuHeader" [control]="menuParams.controls['menuHeader']"></input-validators>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Message to User </label>
            </div>
            <textarea class="control-input control-area" rows="4" cols="50" activeForm [activeForm]="menuParams" id="formSubHeader" [formControlName]="'subHeader'" placeholder="Enter message to user"></textarea>
            <input-validators controlName="menuHeader" [control]="menuParams.controls['subHeader']"></input-validators>
          </div>
          <div class="control-div checkbox-field">
            <mat-checkbox class="checkbox-icon" color="primary" [formControlName]="'isPrivateVariable'"></mat-checkbox>
            <div class="label-left-block">
              <label class="control-label"> Sensitive Inputs </label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'isPrivateVariable'"></app-cms>
            </div>
          </div>
          <div class="control-div checkbox-field no-margin">
            <mat-checkbox class="checkbox-icon" color="primary" [formControlName]="'showPageResults'"></mat-checkbox>
            <div class="label-left-block">
              <label class="control-label"> Show Results Page </label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'showPageResults'"></app-cms>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
    <clickatell-expansion-panel>
      <ng-container header>
        <div class="hh">
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </div>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="menuParams">
          <div class="control-div">
            <label class="control-label"> Point To </label>
            <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
            @if (nodeFlowDetails) {
              <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                [name]="'next'"
                [form]="menuParams"
                [stepId]="nodeFlowDetails.stepId">
              ></next-selector>
            }
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
  </div>
}

@if (configurePanelOpen) {
  <div class="configure-form-container">
    <div class="configure-form-block">
      <div class="configure-form-header">
        <div class="configure-form-block-title">Configure Form</div>
        <div class="close-btn" (click)="closeConfigureFormPanel()"></div>
      </div>
      <div class="configure-form-body">
        <div class="configure-form-left-panel" (click)="clearSelectedPage()">
          <div class="add-page-block">
            <button class="add-page-btn" mat-button [matMenuTriggerFor]="pagesMenu">Add Page</button>
            <mat-menu #pagesMenu="matMenu" class="pages-menu">
              <button mat-menu-item class="pages-menu-item multi-page" (click)="addSelectionPage()">Add Single/Multi-Selection Page</button>
              <button mat-menu-item class="pages-menu-item picker-page" (click)="addPickerPage()">Add Picker Page</button>
              <button mat-menu-item class="pages-menu-item date-page" (click)="addDatePickerPage()">Add Date Picker Page</button>
              <button mat-menu-item class="pages-menu-item input-page" (click)="addInputPage()">Add Input Page</button>
            </mat-menu>
          </div>
          <div class="pages-list">
            @if (pages.length > 0) {
              <div class="pages" (cdkDropListDropped)="dropPage($event)" cdkDropList>
                @for (page of pages; track page; let i = $index) {
                  <div cdkDrag>
                    <div class="custom-placeholder" *cdkDragPlaceholder></div>
                    <div class="page"
                      [class]="pagesInfo[page?.pageType]?.class"
                      [ngClass]="{'selected': selectedPage?.index === i, 'invalid': page.valid === false}"
                      (click)="selectPage(i, $event)"
                      (mouseleave)="closeRemovePageConfirmPanel()">
                      <img class="drag-indicators" src="../../../../../../../../assets/svg/drag-indicator.svg" alt="drag-indicators">
                      <div class="title">{{ page.pageHeader ? page.pageHeader : pagesInfo[page?.pageType]?.title }}</div>
                      <div class="remove-btn"  matTooltip="Delete page" matTooltipClass="menuForm-remove-button-tooltip"
                      matTooltipPosition="above" (click)="openRemovePageConfirmPanel($event, i)"></div>
                      <ng-container *ngTemplateOutlet="removeTooltip; context: { index: i }"></ng-container>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="no-pages">Add a page to start creating a form.</div>
            }
          </div>
        </div>
        <div class="configure-form-right-panel">
          @if (selectedPage) {
            <div>
              <ng-container *ngTemplateOutlet="page"></ng-container>
            </div>
          } @else {
            <div class="no-page-selected">You can configure your pages here.</div>
          }
        </div>
      </div>
      <div class="configure-form-footer">
        <button class="cancel-btn" (click)="closeConfigureFormPanel()">Cancel</button>
        <button class="save-btn" [disabled]="pages.length === 0" (click)="saveFormConfiguration()">Save Form</button>
      </div>
    </div>
  </div>
}

<ng-template #page>
  @if (loadPageInProgress) {
    <loading-icon class="loading-in-progress"></loading-icon>
  } @else {
    @switch (selectedPage.type) {
      @case ('selectionPages') {
        <selection-page #selectionPage [pageData]="selectedPage" [canEdit]="canEdit" (setPageData)="setPageData($event)"></selection-page>
      }
      @case ('pickerPages') {
        <picker-page #pickerPage [pageData]="selectedPage" [canEdit]="canEdit" (setPageData)="setPageData($event)"></picker-page>
      }
      @case ('datePickerPages') {
        <datepicker-page #datePickerPage [pageData]="selectedPage" [canEdit]="canEdit" (setPageData)="setPageData($event)"></datepicker-page>
      }
      @case ('inputPage') {
        <input-page #inputPage [pageData]="selectedPage" [canEdit]="canEdit" (setPageData)="setPageData($event)"></input-page>
      }
    }
  }
</ng-template>

<ng-template #removeTooltip let-index="index">
  @if (removePageConfirmPanelOpened === index) {
    <div class="remove-page-confirm-block">
      <div class="remove-page-confirm-title">Do you want to delete this page?</div>
      <div class="remove-page-confirm-btns">
        <button class="no-btn" (click)="closeRemovePageConfirmPanel()">No</button>
        <button class="yes-btn" (click)="removePage($event, index)">Yes</button>
      </div>
    </div>
  }
</ng-template>
